function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

function handleScroll() {
  var scrollToTopBtn = document.querySelector(".scrollToTopBtn");

  // Show/hide and slide the "Scroll to Top" button based on the scroll position
  if (document.body.scrollTop > 1200 || document.documentElement.scrollTop > 1200) {
    scrollToTopBtn.classList.add("active");
  } else {
    scrollToTopBtn.classList.remove("active");
  }
}

// Attach the scrollToTop function to the button click event
document.querySelector(".scrollToTopBtn").addEventListener("click", scrollToTop);

// Initialize without the active class
document.addEventListener("DOMContentLoaded", function() {
  var scrollToTopBtn = document.querySelector(".scrollToTopBtn");
  scrollToTopBtn.classList.remove("active");
});

// Attach the handleScroll function to the scroll event
window.onscroll = handleScroll;